module.exports = __webpack_public_path__ + "static/masonry-image-7-4d023cd96dd56285a342db3cd06c691f.jpg";